/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actionTypes from './actionTypes';

const initilaState = {
  invoiceDetailsByPQR: [],
  invoiceDetailsByInvoiceNum: {},
  handlingCodeValues: [],
  invoiceQuarter: [],
  invoiceStatusCodeValues: [],
  saveRequestData: {},
  searchInvoiceReportRequest: {
    quarter: '',
    rebateProgramCode: '',
    planType: '',
    page: '0',
    pageSize: '100',
    saveButtonEnable: false,
  },
  selectedClient: '',
  invoiceNumber: '',
  searchClicked: false,
  noRecordFound: false,
  noRecordSearchCount: 0,
  errorMessages: [],
  duplicateInvoice: true,
  errors: {},
  pdfSectionOnePreview: [],
  pdfSectionTwoPreview: [],
  pdfSectionThreePreview: []
};

const isInvoiceNumNotFound = (payload) => {
  if (payload == null || payload === '') return true;
  if (typeof payload === 'string') {
    const lower = payload.toLowerCase();
    return lower.includes('no record') || lower.includes('not found');
  }
  const data = payload?.data ?? payload?.message;
  if (typeof data === 'string') {
    const lower = data.toLowerCase();
    return lower.includes('no record') || lower.includes('not found');
  }
  return false;
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_INVOICE_REPORTS_BY_MFG: {
      return { ...state, invoiceDetailsByPQR: action.payload };
    }
    case actionTypes.GET_DISP_INVOICE_DETAILS_BY_INVOICE_NUM: {
      const notFound = isInvoiceNumNotFound(action.payload);
      return {
        ...state,
        invoiceDetailsByInvoiceNum: notFound
          ? state.invoiceDetailsByInvoiceNum
          : action.payload || {},
        noRecordFound: notFound,
        noRecordSearchCount: (state.noRecordSearchCount || 0) + 1,
        searchClicked: !state.searchClicked,
      };
    }
    case actionTypes.SET_INVOICE_REPORT_NO_RECORD_FOUND: {
      return {
        ...state,
        noRecordFound: action.payload,
      };
    }
    case actionTypes.GET_HANDLING_CODE: {
      return { ...state, handlingCodeValues: action.payload };
    }
    case actionTypes.GET_INVOICE_QUARTER: {
      return { ...state, invoiceQuarter: action.payload };
    }
    case actionTypes.GET_ALL_REBATE_PROGRAMS: {
      return { ...state, rebateProgramCode: action.payload };
    }
    case actionTypes.SEARCH_INVOICE_REPORT_REQUEST: {
      return { ...state, searchInvoiceReportRequest: { ...action.payload } };
    }
    case actionTypes.SET_INVOICE_REPORT_SELECTED_CLIENT: {
      return { ...state, selectedClient: action.payload };
    }
    case actionTypes.SET_INVOICE_REPORT_NUMBER: {
      return { ...state, invoiceNumber: action.payload };
    }
    case actionTypes.INVOICE_LETTER_TABLE_DATA:
      return {
        ...state,
        invoiceLetterTableData: action.invoiceLetterTableData,
      };
    case actionTypes.INVOICE_GET_PRINT_PREVIEW_DISPLAY: {
      return { ...state, pdfPreview: action.pdfPreview };
    }
    case actionTypes.INVOICE_GET_REPORT_COVER_DISPLAY: {
      return { ...state, pdfCoverPreview: action.pdfCoverPreview };
    }
    case actionTypes.INVOICE_GET_REPORT_SECTION_ONE_DISPLAY: {
      return { ...state, pdfSectionOnePreview: action.pdfSectionOnePreview };
    }
    case actionTypes.INVOICE_GET_REPORT_SECTION_TWO_DISPLAY: {
      return { ...state, pdfSectionTwoPreview: action.pdfSectionTwoPreview };
    }
    case actionTypes.INVOICE_GET_REPORT_SECTION_THREE_DISPLAY: {
      return {
        ...state,
        pdfSectionThreePreview: action.pdfSectionThreePreview,
      };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtr: action.defaultQtr };
    }
    case 'GET_SAVE_COVER_LETTER': {
      return { ...state, saveCoverLetter: action.payload };
    }
    case 'GET_INV_GRID_FLAG': {
      return { ...state, invGridFlag: action.payload };
    }
    case actionTypes.SET_ERROR_MESSAGES_INNVOICE_REPORT: {
      return { ...state, errorMessages: action.payload };
    }
    case actionTypes.SET_ERRORS: {
      return { ...state, errors: action.payload };
    }
    case actionTypes.INVOICE_GET_UPDATE_DUPLICATEINVOICE: {
      return { ...state, duplicateInvoice: action.data.duplicateInvoice };
    }
    case actionTypes.SET_IS_SEARCH_CLICKED: {
      return { ...state, searchClicked: action.payload };
    }
    case actionTypes.RESET_DISPLAY_INVOICE_REPORT_STORE: {
      return { ...initilaState };
    }

    default:
      return state;
  }
};

export default reducer;
